import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React, { Component } from 'react';
import { noop } from 'lodash';
import PropTypes from 'prop-types';
import Truncate from 'react-truncate';
import cx from 'classnames';
import Text from '../../elementals/text';
class TextTruncate extends Component {
    state = {
        readMore: true,
        isMounted: false,
    };
    static propTypes = {
        children: PropTypes.node.isRequired,
        elmId: PropTypes.string,
        readMoreLabel: PropTypes.node,
        readLessLabel: PropTypes.node,
        lines: PropTypes.number,
        width: PropTypes.number,
        onToggle: PropTypes.func,
        ellipsis: PropTypes.string,
        cls: PropTypes.shape({
            readMoreLabel: PropTypes.string,
            readLessLabel: PropTypes.string,
        }),
    };
    static defaultProps = {
        cls: {},
        elmId: 'truncatedText',
        lines: 3,
        width: 0,
        readMoreLabel: 'Show More',
        readLessLabel: 'Show Less',
        ellipsis: '...',
        onToggle: noop,
    };
    toggleLines = event => {
        event.preventDefault();
        this.setState({
            readMore: !this.state.readMore,
        });
        this.props.onToggle(this.state.readMore);
    };
    componentDidMount() {
        setTimeout(() => {
            this.setState({ isMounted: true });
        }, 100);
    }
    render() {
        const { children, elmId, readMoreLabel, readLessLabel, lines, cls, ellipsis, width, ...rest } = this.props;
        return (_jsx(Text, { ...rest, "data-elm-id": `${elmId}_text`, children: _jsxs(Truncate, { lines: this.state.readMore ? lines : 0, width: width, ellipsis: _jsxs("span", { children: [ellipsis, readMoreLabel && (_jsx("a", { className: cx(cls.readMoreLabel, 'u-pointer-cursor'), onClick: this.toggleLines, "data-elm-id": `${elmId}_more_label`, children: readMoreLabel }))] }), children: [this.state.isMounted && children, this.state.readMore ? null : (_jsxs("a", { onClick: this.toggleLines, className: cx(cls.readLessLabel, 'u-pointer-cursor'), "data-elm-id": `${elmId}_less_label`, children: [' ', readLessLabel] }))] }) }));
    }
}
export default TextTruncate;
//# sourceMappingURL=index.js.map